import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import './RequireAuth.css';

// Gate for protected pages (broker/admin). When logged out — or when the token
// expires mid-session — it opens the sign-in dialog and leaves the page empty
// behind it; the site header's Log In button is the way back in if the dialog
// is dismissed. `roles` lists the roles allowed in; leave it off to allow
// anyone signed in.
const RequireAuth = ({ children, roles }) => {
    const { isLoggedIn, roles: userRoles, openLogin, email } = useAuth();

    useEffect(() => {
        if (!isLoggedIn) openLogin();
    }, [isLoggedIn, openLogin]);

    const allowed = !roles || roles.some((role) => userRoles.includes(role));
    if (isLoggedIn && allowed) return children;

    if (isLoggedIn) {
        return (
            <p className="auth-gate-message">
                {email} doesn't have access to this page.
            </p>
        );
    }

    return (
        <p className="auth-gate-message">
            <button type="button" className="auth-gate-link" onClick={openLogin}>Sign in</button> to view this page.
        </p>
    );
};

export default RequireAuth;
